import { render, staticRenderFns } from "./ProjectTitle.vue?vue&type=template&id=5cf1a025&"
import script from "./ProjectTitle.vue?vue&type=script&lang=js&"
export * from "./ProjectTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports